<script>
/* eslint-disable no-undef */
import axios from 'axios'
import {getCurrentInstance} from 'vue';

export default {
    name: 'BaseApp',
    data: function () {

        const domain = process.env.VUE_APP_DOMAIN !== undefined ? process.env.VUE_APP_DOMAIN : ''
        const isProd = location.href.search('mango-office') > -1;
        const app = getCurrentInstance();
        return {
            domain: domain,
            apiUrl: domain + '/api/' + this.pascalCaseToKebab(app.type.name) + '/',
            isProd: isProd
        }
    },
    methods: {
        initData(additionalSendData, actionApi = '') {
            // this.$root.getDataElement = this.getDataElement;
            const self = this;
            return new Promise((resolve, reject) => {
                const app = getCurrentInstance();
                const dataVarName = app.type.name + 'Data'
                if (Object.hasOwnProperty.call(window, dataVarName) && window[dataVarName]) {
                    for (let k in this.$data) {
                        if (window[dataVarName][k] !== undefined) {
                            this.$data[k] = window[dataVarName][k];
                        }
                    }
                    window[dataVarName] = null;

                    this.$nextTick(function () {
                        resolve()
                    })
                } else {

                    // Заполняем данные через АПИ
                    let sendData = {
                        action: 'getData',
                        sessid: this.sessid
                    }
                    if (typeof additionalSendData === 'object') {
                        Object.assign(sendData, additionalSendData);
                    }

                    if (actionApi) {
                        actionApi = actionApi + '/'
                    }

                    console.log(this.domain);
                    axios.post(this.domain + '/api/' + this.pascalCaseToKebab(app.type.name) + '/' + actionApi, null, {
                        params: sendData,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    })
                        .then(function (response) {
                            if (actionApi) {
                                for (let key in response.data.data) {
                                    if (key !== 'status') {
                                        self.key = response.data.data[key]
                                    }
                                }
                            } else {
                                for (let key in response.data) {
                                    if (key !== 'status') {
                                        self.key = response.data[key]
                                    }
                                }
                            }

                            self.$nextTick(function () {
                                resolve()
                            })
                        })
                        .catch(() => {
                            reject()
                        });
                }
            })
        },

        pascalCaseToKebab(string) {
            const camelCaseString = string.charAt(0).toLowerCase() + string.slice(1);
            return camelCaseString.replace(/[A-Z]?([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
        },
        getDataElement(elementId) {
            return this.isProd === false ? elementId : null;
        },

        isEcommerceArrayExists(r) {
          if (typeof window.mgoTriggerEvent === 'undefined') {
            return false;
          }

          return Object.prototype.hasOwnProperty.call(r, 'arrEcommerce');
        },
        runViewProductEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('viewProduct', [r.arrEcommerce['yandex']]);
          }
        },
        runAddOrDelProductCartEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('addOrDelProductCart', [r['arrEcommerce']['yandex']]);
          }
        },
        runOrderEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('orderEcommerce', [r['arrEcommerce']['yandex']]);
          }
        },
        setNumbersLocationClick() {
            if (typeof window.mgoTriggerEvent !== 'function') {
                return;
            }

            window.mgoTriggerEvent('numbers_location_click');
        }
    }
}
</script>